import { getIn, useFormikContext } from "formik"
import * as Yup from 'yup'

import { FormikCheckBox, FormikNotesArea } from "../../../../../../components/widgets"
import { useMemo } from "react"
import { IWebFileAttachment } from "../../../../../core/applications"

// Site Inspection
export interface IDLMApplicantSigned  {
  verdict: string
  workflow: string
  note: string
  noteAttachments: Array<IWebFileAttachment>
  skipSCDF: boolean
}

export const initDLMApplicantSignedValues: IDLMApplicantSigned = {
  verdict: '',
  workflow: '',
  note: '',
  noteAttachments: [],
  skipSCDF: false,
}

export const DLMApplicantSignedSchema: any = Yup.object({
  appState: Yup.string().trim(),
  verdict: Yup.string().trim(),
  workflow: Yup.string().trim(),
  note: Yup.string().trim().label('Note')
   .when('verdict', {
    is: (val: string) => (val !== 'approved'),
    then: (schema) => schema.required(),    
  }),  
  noteAttachments: Yup.array(),
  skipSCDF: Yup.bool().label('Skip SCDF')
});

export const DLMApplicantSignedForm = () => {

  const { values } = useFormikContext();
  const verdict = useMemo(() => {
    if (! values) return '';
    return getIn(values, 'verdict');   
  }, [values]);
  
  return (
  <>
  { (verdict === 'approved') && 
  <div className="row my-2">
    <FormikCheckBox size="12" name="skipSCDF"  label="Skip SCDF" />  
  </div>
  }
  <FormikNotesArea required={verdict !== 'approved'} />
  </>
  )
}